import { z } from "zod";
export const AI_INTERPRETATIONS = ["record", "narrate", "assess"];
export const AI_STYLE_LIMITS = {
    organisationGuide: 15,
    surveyTypeGuide: 10,
    phrasings: 10,
};
const placeholderRule = "Keep the author's own organisation name, role titles and terms. Replace every person, other organisation, place, date, identifier and figure with a fictional placeholder such as Mr Example, Example Clinic or 12 March 2026.";
const guide = (scope, max) => z
    .array(z.string())
    .describe(`Up to ${max} short instructions, one line each, for how ${scope} are written: voice, person, tense, register, how people and organisations are named, terminology, and how dates, numbers and units are written in sentences. Each item is something to do, never something absent. Never layout, headings or section order. ${placeholderRule}`);
const phrasings = z
    .array(z.string())
    .describe(`Up to ${AI_STYLE_LIMITS.phrasings} short sentence patterns the author uses again and again, with square-bracketed placeholders for anything case-specific, such as '[Title Surname] reported that [what was reported].' Never a real sentence from an example. ${placeholderRule}`);
export const aiOrganisationStyleSchema = z.object({
    guide: guide("this organisation's reports", AI_STYLE_LIMITS.organisationGuide),
    phrasings,
});
export const aiSurveyTypeStyleSchema = z.object({
    guide: guide("answers in this report type differ from the organisation style, including kinds of content they leave out", AI_STYLE_LIMITS.surveyTypeGuide),
});
export const aiAnswerStyleSchema = z.object({
    name: z.string().describe("The question's name, exactly as listed."),
    interpretation: z
        .enum(AI_INTERPRETATIONS)
        .describe("How far the examples' answers go beyond the facts. 'record': only what the sources establish. 'narrate': a connected account of what happened and what changed, with no new judgement. 'assess': an account followed by the author's professional analysis."),
    length: z
        .string()
        .describe("How long the examples' answers are, as a short target such as '2 to 3 dot points' or 'one sentence'."),
    example: z
        .string()
        .describe(`A short answer of at most 60 words about an invented situation unlike any in the examples, written the way the examples answer this question: the same form, length and kind of phrasing, but never their facts, events, figures or sentences. ${placeholderRule}`),
});
//# sourceMappingURL=aiStyle.js.map